import { useState, useEffect, useRef } from "react";

const LazyImage = ({
  src,
  alt = "",
  className = "",
  onClick,
  onError,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    let observer;
    if (imgRef.current && !isVisible) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.disconnect();
            }
          });
        },
        { rootMargin: "100px" }
      );
      observer.observe(imgRef.current);
    }
    return () => observer && observer.disconnect();
  }, [isVisible]);

  return (
    <div
      ref={imgRef}
      className={`relative overflow-hidden bg-[#111] ${
        className.includes("absolute") ? "" : "block"
      }`}
      style={{ minHeight: "100%", minWidth: "100%" }}
    >
      {isVisible && (
        <img
          src={src}
          alt={alt}
          className={`${className} transition-opacity duration-700 ${
            isLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setIsLoaded(true)}
          onError={onError}
          onClick={onClick}
          loading="lazy"
          {...props}
        />
      )}
      {!isLoaded && (
        <div className="absolute inset-0 bg-neutral-800 animate-pulse"></div>
      )}
    </div>
  );
};

export default LazyImage;
